export const styles = {
    moduleCarousel: {
        w: "full",
    },
    moduleGrid: {
        w: "full",
        px: { base: "16px", xl: "32px" },
    },
    moduleGridPadding: {
        py: { base: "16px", xl: "32px" },
    },
    linksWrapperGrid: {
        alignItems: "center",
        columnGap: "18px",
        rowGap: "1px",
        width: "full",
        flexWrap: "wrap" as const,
    },
    linksWrapperCarousel: {
        alignItems: "center",
        columnGap: "12px",
        width: "full",
        flexWrap: "wrap" as const,
    },
    linkButtonGrid: {
        justifyContent: "space-between",
        alignItems: "center",
        py: "18px",
        _hover: { textDecoration: "none" },
        fontSize: "16px",
        lineHeight: "16px",
        letterSpacing: "0.4px",
        fontWeight: "bold",
    },
    linkButtonCarousel: {
        justifyContent: "space-between",
        alignItems: "center",
        minH: "56px",
        py: "16px",
        _hover: { textDecoration: "none" },
        fontSize: "16px",
        lineHeight: "16px",
        letterSpacing: "0.4px",
        fontWeight: "bold",
    },
    imageOnlyTile: {
        w: "full",
        h: "full",
        minH: 0,
        minW: 0,
        position: "relative" as const,
        overflow: "hidden",
        _before: {
            content: '""',
            display: "block",
            paddingTop: "100%",
        },
    },
    imageOnlyInner: {
        position: "absolute" as const,
        inset: 0,
    },
    imageOnlyFallback: {
        position: "relative" as const,
        w: "full",
        minW: 0,
        aspectRatio: ["1/1", "6/7"],
        overflow: "hidden",
    },
    imageOnlyFallbackFill: {
        position: "absolute" as const,
        inset: 0,
    },
};
